import React, { useState, useEffect } from "react";
import {
  Alert,
  Button,
  ButtonGroup,
  Container,
  Card,
  Col,
  Form,
  Row,
  Modal,
  Spinner,
  Dropdown,
  Tooltip,
  OverlayTrigger,
  Nav,
  Table,
} from "react-bootstrap";
import { Typeahead } from "react-bootstrap-typeahead";
import { useDispatch, useSelector } from "react-redux";
import ReactExport from "react-export-excel";
import moment from "moment";
import * as Yup from "yup";
import { Formik } from "formik";

import CustomNavbar from "../../../components/CustomNavbar";
import CustomTable from "../../../components/CustomTable";
import CustomPagint from "../../../components/CustomPagint";

import messages from "../../../redux/messages";
import { getGeneralInfoById } from "../../../redux/descriptorsProfiles/GeneralInfo/actions";
import { getPurpose } from "../../../redux/descriptorsProfiles/Purpose/actions";
import { getMeasurementUnit } from "../../../redux/descriptorsProfiles/MeasurementUnit/actions";
import {
  getTraining,
  saveTraining,
  editTraining,
  deleteTraining,
  editIndispensable,
} from "../../../redux/descriptorsProfiles/Formation/actions";
import { getTitles } from "../../../redux/descriptorsProfiles/Titles/actions";
import {
  savePreparation,
  editPreparation,
  getPreparation,
  editIndispensablePreparation,
  deletePreparation,
} from "../../../redux/descriptorsProfiles/Preparation/actions";
import { getCourse } from "../../../redux/descriptorsProfiles/Courses/actions";
import { getTechnicalKnowledge } from "../../../redux/descriptorsProfiles/TechnicalKnowledge/actions";
import {
  getExperience,
  saveExperience,
  editExperience,
  deleteExperience,
} from "../../../redux/descriptorsProfiles/Experience/actions";
import {
  saveTechnicalKnowledgeAcquired,
  editTechnicalKnowledgeAcquired,
  getTechnicalKnowledgeAcquired,
  deleteTechnicalKnowledgeAcquired,
  editIndispensableTechnicalKnowledgeAcquired,
} from "../../../redux/descriptorsProfiles/TechnicalKnowledgeAcquired/actions";

const JobProfile = (props) => {
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  const [_editPreparation, setEditPreparation] = useState(false);
  const [indexPreparation, setIndexPreparation] = useState(0);
  const [editItemPreparation, setEditItemPreparation] = useState({});
  const [editTecnicalKnowledge, setEditTecnicalKnowledge] = useState(false);
  const [indexTecnicalKnowledge, setIndexTecnicalKnowledge] = useState(0);
  const [editItemTecnicalKnowledge, setEditItemTecnicalKnowledge] = useState(
    {}
  );
  const [_editExperience, setEditExperience] = useState(false);
  const [indexExperience, setIndexExperience] = useState(0);
  const [editItemExperience, setEditItemExperience] = useState({});
  const [showModalJobProfile, setShowModalJobProfile] = useState(false);
  const [showModalPreparation, setShowModalPreparation] = useState(false);
  const [showModalTecnicalKnowledge, setShowModalTecnicalKnowledge] =
    useState(false);
  const [showModalExperience, setShowModalExperience] = useState(false);
  const [filter, setFilter] = useState("");
  const [validatedJobProfile, setValidatedJobProfile] = useState(false);
  const [validatedPreparation, setValidatedPreparation] = useState(false);
  const [validatedExperience, setValidatedExperience] = useState(false);
  const [validatedTecnicalKnowledge, setValidatedTecnicalKnowledge] =
    useState(false);
  const [titleSelected, setTitleSelected] = useState([]);
  const [courseSelected, setCourseSelected] = useState([]);
  const [knowledgeSelected, setknowledgeSelected] = useState([]);

  const dispatch = useDispatch();
  const userRoles = useSelector((store) => store.auth.userRoles);

  const schemaJobProfile = Yup.object().shape({
    nombre: Yup.string().required("**Campo requerido"),
    titulo: Yup.string().required("**Campo requerido"),
    indispensable_formacion: Yup.boolean().notRequired(""),
  });

  const schemaPreparation = Yup.object().shape({
    descripcion: Yup.string().required("**Campo requerido"),
    curso: Yup.string().required("**Campo requerido"),
    indispensable: Yup.boolean().notRequired(""),
  });

  const schemaTecnicalKnowledge = Yup.object().shape({
    nombre: Yup.string().required("**Campo requerido"),
    descripcion: Yup.string().required("**Campo requerido"),
    conocimiento: Yup.string().required("**Campo requerido"),
    nivel_profundidad: Yup.number()
      .required("**Campo requerido")
      .typeError("Debe especificar un numero")
      .integer("El número no puede tener decimales.")
      .min(1, "El número debe ser igual o mayor a 1.")
      .max(3, "El número debe ser igual o menor a 3."),
    indispensableConocimiento: Yup.boolean().notRequired(""),
  });

  const schemaExperience = Yup.object().shape({
    // detalle: Yup.string().required("**Campo requerido"),
    tiempo: Yup.number()
      .required("**Campo requerido")
      .typeError("Debe especificar un numero")
      .integer("El número no puede tener decimales.")
      .min(0, "El número debe ser igual o mayor a 0."),
    tiempo_2: Yup.number()
      .required("**Campo requerido")
      .typeError("Debe especificar un numero")
      .integer("El número no puede tener decimales.")
      .min(0, "El número debe ser igual o mayor a 0."),
    experiencia_tipo_institucion: Yup.boolean().notRequired(""),
    experiencia_tipo_institucion_detalle: Yup.string().when(
      "experiencia_tipo_institucion",
      {
        is: true,
        then: Yup.string().required("**Campo requerido"),
      }
    ),
    experiencia_tipo_cargo: Yup.boolean().notRequired(""),
    experiencia_tipo_cargo_detalle: Yup.string().when(
      "experiencia_tipo_cargo",
      {
        is: true,
        then: Yup.string().required("**Campo requerido"),
      }
    ),
  });

  const { coursesLength, courses, coursesError } = useSelector(
    (store) => store.course
  );
  const loadingCourse = useSelector((store) => store.course.loading);
  const {
    technicalKnowledgesLength,
    technicalKnowledges,
    technicalKnowledgeError,
  } = useSelector((store) => store.technicalKnowledge);
  const technicalKnowledgeLoading = useSelector(
    (store) => store.technicalKnowledge.loading
  );

  const { experiencesLength, experiences, experienceError } = useSelector(
    (store) => store.experience
  );
  const experienceLoading = useSelector((store) => store.experience.loading);

  const { loading, titlesLength, titles, titleError } = useSelector(
    (store) => store.titles
  );

  const { trainingsLength, trainings, trainingError } = useSelector(
    (store) => store.training
  );
  const trainingLoading = useSelector((store) => store.training.loading);
  const trainingSaveLoading = useSelector(
    (store) => store.training.saveLoading
  );
  const trainingFormError = useSelector((store) => store.training.formError);
  const pages = Math.ceil(trainingsLength / limit);

  const { preparationsLength, preparations, preparationError } = useSelector(
    (store) => store.preparation
  );
  const preparationLoading = useSelector((store) => store.preparation.loading);
  const preparationSaveLoading = useSelector(
    (store) => store.preparation.saveLoading
  );
  const preparationFormError = useSelector(
    (store) => store.preparation.formError
  );

  const {
    technicalKnowledgeAcquiredsLength,
    technicalKnowledgeAcquireds,
    technicalKnowledgeAcquiredError,
  } = useSelector((store) => store.technicalKnowledgeAcquired);
  const technicalKnowledgeAcquiredLoading = useSelector(
    (store) => store.technicalKnowledgeAcquired.loading
  );
  const technicalKnowledgeAcquiredSaveLoading = useSelector(
    (store) => store.technicalKnowledgeAcquired.saveLoading
  );
  const technicalKnowledgeAcquiredFormError = useSelector(
    (store) => store.technicalKnowledgeAcquired.formError
  );

  const { generalInfo, loadingById, formError } = useSelector(
    (store) => store.generalInfo
  );

  let titleOptions = [];
  titles &&
    titles.map((titl) => {
      titleOptions = [
        ...titleOptions,
        {
          id: titl.id,
          label: titl.titulo,
          titleObject: titl,
        },
      ];
    });

  let courseOptions = [];
  courses &&
    courses.map((cours) => {
      courseOptions = [
        ...courseOptions,
        {
          id: cours.id,
          label: cours.nombre,
          courseObject: cours,
        },
      ];
    });

  let knowledgeOptions = [];
  technicalKnowledges &&
    technicalKnowledges.map((know) => {
      knowledgeOptions = [
        ...knowledgeOptions,
        {
          id: know.id,
          label: know.nombre,
          knowObject: know,
        },
      ];
    });

  const columns = [
    {
      Header: "Formación",
      accessor: "nombre",
      Filter: "",
    },
    {
      Header: "Título",
      accessor: "list_formacion[0].titulo",
      Filter: "",
    },
    {
      Header: "Nivel de educación",
      accessor: "list_formacion[0].list_nivel_academico[0].nombre",
      Filter: "",
    },
    {
      Header: "Área de conocimiento",
      accessor: "list_formacion[0].list_area_conocimiento[0].nombre",
      Filter: "",
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) =>
      props.match.params.miDescriptor ? null : (
          <div className="d-flex flex-wrap justify-content-end align-items-center">
            <div
              className="btn-group d-flex flex-wrap justify-content-end align-items-center"
              role="group"
            >
              <OverlayTrigger
                placement="auto"
                overlay={<Tooltip {...props}>Indispensable</Tooltip>}
              >
                <Form.Check
                  type="switch"
                  id={"Formacion " + value.row.original.id}
                  defaultChecked={value.row.original.indispensable}
                  onChange={(e) =>
                    handleCheckbox(
                      e.target.checked,
                      value.row.original.id,
                      value.row.index
                    )
                  }
                />
              </OverlayTrigger>
              <OverlayTrigger
                placement="auto"
                overlay={<Tooltip {...props}>Editar</Tooltip>}
              >
                <Button
                  size="sm"
                  variant="link"
                  type="button"
                  onClick={() => onEdit(value.row.original, value.row.index)}
                >
                  <i className="material-icons">edit</i>
                </Button>
              </OverlayTrigger>
              <OverlayTrigger
                placement="auto"
                overlay={<Tooltip {...props}>Eliminar</Tooltip>}
              >
                <Button
                  size="sm"
                  className="text-danger"
                  variant="link"
                  type="button"
                  onClick={() =>
                    onDelete(value.row.original.id, value.row.index)
                  }
                >
                  <i className="material-icons">close</i>
                </Button>
              </OverlayTrigger>
            </div>
          </div>
        ),
    },
  ];

  // Métodos
  const _getTraining = (offs = offset, lim = limit, filt = filter) =>
    dispatch(
      getTraining({
        // offset: offs,
        // limit: lim,
        tipo_busqueda: "descriptor_id",
        filter: parseInt(props.match.params.id),
      })
    );
  const _getPreparation = () =>
    dispatch(
      getPreparation({
        tipo_busqueda: "descriptor_id",
        filter: parseInt(props.match.params.id),
      })
    );

  const _getTechnicalKnowledgeAcquired = () =>
    dispatch(
      getTechnicalKnowledgeAcquired({
        tipo_busqueda: "descriptor_id",
        filter: parseInt(props.match.params.id),
      })
    );

  useEffect(() => {
    _getTraining();
    _getPreparation();
    _getTechnicalKnowledgeAcquired();
    dispatch(
      getExperience({
        tipo_busqueda: "descriptor_id",
        filter: parseInt(props.match.params.id),
      })
    );
    dispatch(getGeneralInfoById(parseInt(props.match.params.id)));
    setTitleSelected([]);
    dispatch(getTitles({}));
    dispatch(getCourse({}));
    dispatch(getTechnicalKnowledge({}));
  }, [props.match.params.id]);

  useEffect(() => {
    if (generalInfo && generalInfo && generalInfo.list_proposito_general) {
      setTitleSelected([
        {
          id: generalInfo.list_proposito_general[0].id,
          label: generalInfo.list_proposito_general[0].nombre,
        },
      ]);
    }
  }, [generalInfo]);

  const onAddFunction = () => {
    setTitleSelected([]);
    setShowModalJobProfile(true);
    setEdit(false);
    setValidatedJobProfile(false);
  };

  const onAddPreparation = () => {
    setCourseSelected([]);
    setShowModalPreparation(true);
    setEditPreparation(false);
    setValidatedPreparation(false);
  };

  const onAddTecnicalKnowledge = () => {
    setknowledgeSelected([]);
    setShowModalTecnicalKnowledge(true);
    setEditTecnicalKnowledge(false);
    setValidatedTecnicalKnowledge(false);
  };

  const onAddExperience = () => {
    setShowModalExperience(true);
    setEditExperience(false);
    setEditItemExperience({});
    setValidatedExperience(false);
  };

  const onEdit = (item, index) => {
    setTitleSelected([
      {
        id: item.formacion,
        label: item.list_formacion[0].titulo,
        titleObject: item.list_formacion[0],
      },
    ]);
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowModalJobProfile(true);
    setValidatedJobProfile(false);
  };

  const onEditPreparation = (item, index) => {
    setCourseSelected([
      {
        id: item.curso,
        label: item.list_curso[0].nombre,
        courseObject: item.list_curso[0],
      },
    ]);
    setIndexPreparation(index);
    setEditPreparation(true);
    setEditItemPreparation(item);
    setShowModalPreparation(true);
    setValidatedPreparation(false);
  };

  const onEditTecnicalKnowledge = (item, index) => {
    setknowledgeSelected([
      {
        id: item.conocimiento,
        label: item.list_conocimiento[0].nombre,
        courseObject: item.list_conocimiento[0],
      },
    ]);
    setIndexTecnicalKnowledge(index);
    setEditTecnicalKnowledge(true);
    setEditItemTecnicalKnowledge(item);
    setShowModalTecnicalKnowledge(true);
    setValidatedTecnicalKnowledge(false);
  };

  const onEditexperience = (item, index) => {
    setIndexExperience(index);
    setEditExperience(true);
    setEditItemExperience(item);
    setShowModalExperience(true);
    setValidatedExperience(false);
  };

  const onSubmitJobProfile = async (req) => {
    const _req = {
      nombre: req.nombre,
      descriptor: parseInt(props.match.params.id),
      formacion: parseInt(req.titulo),
      indispensable: req.indispensable_formacion,
    };

    if (!edit) {
      dispatch(saveTraining(_req, setShowModalJobProfile));
    } else {
      dispatch(editTraining(_req, editItem.id, index, setShowModalJobProfile));
    }
  };
  const onSubmitPreparation = async (req) => {
    const _req = {
      descripcion: req.descripcion,
      descriptor: parseInt(props.match.params.id),
      curso: parseInt(req.curso),
      indispensable: req.indispensable,
    };
    if (!_editPreparation) {
      dispatch(savePreparation(_req, setShowModalPreparation));
    } else {
      dispatch(
        editPreparation(
          _req,
          editItemPreparation.id,
          indexPreparation,
          setShowModalPreparation
        )
      );
    }
  };

  const onSubmitTecnicalKnowledge = async (req) => {
    const _req = {
      nombre: req.nombre,
      descripcion: req.descripcion,
      descriptor: parseInt(props.match.params.id),
      conocimiento: parseInt(req.conocimiento),
      nivel_profundidad: parseInt(req.nivel_profundidad),
      indispensable: req.indispensableConocimiento,
    };
    if (!editTecnicalKnowledge) {
      dispatch(
        saveTechnicalKnowledgeAcquired(_req, setShowModalTecnicalKnowledge)
      );
    } else {
      dispatch(
        editTechnicalKnowledgeAcquired(
          _req,
          editItemTecnicalKnowledge.id,
          indexTecnicalKnowledge,
          setShowModalTecnicalKnowledge
        )
      );
    }
  };

  const onSubmitExperience = async (req) => {
    req.descriptor = parseInt(props.match.params.id);
    if (!req.experiencia_tipo_institucion) {
      req.experiencia_tipo_institucion_detalle = "";
    }
    if (!req.experiencia_tipo_cargo) {
      req.experiencia_tipo_cargo_detalle = "";
    }
    if (!_editExperience) {
      dispatch(saveExperience(req, setShowModalExperience));
    } else {
      dispatch(
        editExperience(
          req,
          editItemExperience.id,
          indexExperience,
          setShowModalExperience
        )
      );
    }
  };

  const handleCheckbox = (checked, checkValue, rowIndex) => {
    if (checked) {
      const _req = {
        indispensable: true,
      };
      dispatch(editIndispensable(_req, checkValue, index));
    } else {
      const _req = {
        indispensable: false,
      };
      dispatch(editIndispensable(_req, checkValue, index));
    }
  };

  const handleCheckboxPreparation = (checked, checkValue, rowIndex) => {
    if (checked) {
      const _req = {
        indispensable: true,
      };
      dispatch(editIndispensablePreparation(_req, checkValue, index));
    } else {
      const _req = {
        indispensable: false,
      };
      dispatch(editIndispensablePreparation(_req, checkValue, index));
    }
  };

  const handleCheckboxTecnicalKnowledgeAcquired = (
    checked,
    checkValue,
    rowIndex
  ) => {
    if (checked) {
      const _req = {
        indispensable: true,
      };
      dispatch(
        editIndispensableTechnicalKnowledgeAcquired(_req, checkValue, index)
      );
    } else {
      const _req = {
        indispensable: false,
      };
      dispatch(
        editIndispensableTechnicalKnowledgeAcquired(_req, checkValue, index)
      );
    }
  };

  const onDelete = (id, index) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteTraining(id, index));
      window.alert("Se borro este archivo");
    }
  };

  const onDeletePreparation = (id, index) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deletePreparation(id, index));
      window.alert("Se borro este archivo");
    }
  };

  const onDeleteTecnicalKnowledge = (id, index) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteTechnicalKnowledgeAcquired(id, index));
      window.alert("Se borro este archivo");
    }
  };

  const onDeleteExperience = (id, index) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteExperience(id, index));
      window.alert("Se borro este archivo");
    }
  };

  return (
    <>
      <Container>
        {loadingById ? (
          <div className="d-flex justify-content-center">
            <Spinner
              animation="border"
              role="status"
              className="d-flex justify-content-center"
            />
          </div>
        ) : (
          <>
            <Col className="mt-4">
              <Col className="mx-3 d-flex flex-wrap justify-content-between align-items-center">
                <Row className="pl-md-4 pr-md-3 pl-2 pr-1 justify-content-end align-items-center flex-nowrap">
                  <h6 className="font-weight-bold text-uppercase">
                    Perfil del puesto
                  </h6>
                  { props.match.params.miDescriptor ? null : (
                    <Col xs="auto">
                      <OverlayTrigger
                        placement="auto"
                        overlay={
                          <Tooltip {...props}>Agregar formación</Tooltip>
                        }
                      >
                        <Button
                          variant="primary"
                          size="sm"
                          className="rounded-pill"
                          onClick={() => onAddFunction()}
                        >
                          Crear nuevo <i className="material-icons">add</i>
                        </Button>
                      </OverlayTrigger>
                    </Col>
                  )}
                </Row>
              </Col>
              {!trainingLoading &&
                trainingsLength === 0 &&
                trainingError === "" && (
                  <Col>
                    <hr />
                  </Col>
                )}
            </Col>
            <Col>
              <Col className="px-2">
                {trainingLoading ? (
                  <div className="d-flex justify-content-center">
                    <Spinner
                      animation="border"
                      role="status"
                      className="d-flex justify-content-center"
                    />
                  </div>
                ) : (
                  trainingsLength > 0 && (
                    <>
                      <Card className="border-0">
                        <Card.Body className="px-1 px-sm-2">
                          <CustomTable columns={columns} data={trainings} />
                        </Card.Body>
                      </Card>
                      {/* <CustomPagint
                      limit={limit}
                      setLimit={setLimit}
                      offset={offset}
                      setOffset={setOffset}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                      dataLenght={trainingsLength}
                      pages={pages}
                      pagFunc={_getTraining}
                    /> */}
                    </>
                  )
                )}
                {!trainingLoading &&
                  trainingsLength === 0 &&
                  trainingError === "" && (
                    <Alert variant="info" className="my-4">
                      Aún no hay registros, comience agregando algunos
                    </Alert>
                  )}
                {!!trainingError && (
                  <Alert variant="danger" className="mt-4 mb-1">
                    {trainingError}
                  </Alert>
                )}
              </Col>
            </Col>
            <Col className="mt-4">
              <Col className="mx-3 d-flex flex-wrap justify-content-between align-items-center">
                <Row className="pl-md-4 pr-md-3 pl-2 pr-1 justify-content-end align-items-center flex-nowrap">
                  <h6 className="font-weight-bold text-uppercase">
                    Preparación
                  </h6>
                  { props.match.params.miDescriptor ? null : (
                    <Col xs="auto">
                      <OverlayTrigger
                        placement="auto"
                        overlay={
                          <Tooltip {...props}>Agregar preparación</Tooltip>
                        }
                      >
                        <Button
                          variant="primary"
                          size="sm"
                          className="rounded-pill"
                          onClick={() => onAddPreparation()}
                        >
                          Crear nuevo <i className="material-icons">add</i>
                        </Button>
                      </OverlayTrigger>
                    </Col>
                  )}
                </Row>
              </Col>
              <Col>
                <hr className="mb-0" />
              </Col>
            </Col>
            <Col>
              <Col className="px-2">
                {preparationLoading ? (
                  <div className="d-flex justify-content-center">
                    <Spinner
                      animation="border"
                      role="status"
                      className="d-flex justify-content-center"
                    />
                  </div>
                ) : (
                  preparationsLength > 0 && (
                    <>
                      {preparations.map((item, index) => (
                        <div class="table-responsive mx-2">
                          <Table borderless>
                            <thead>
                              <tr>
                                <th style={{ fontWeight: "normal" }}>
                                  Curso/Seminario/Pasantía
                                </th>
                                <th style={{ fontWeight: "normal" }}>
                                  Duración
                                </th>
                                <th></th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr className="my-0">
                                <td className="my-0">
                                  <Form.Control
                                    value={item.list_curso[0].nombre}
                                    className="rounded-pill"
                                    type="text"
                                    disabled
                                  ></Form.Control>
                                </td>
                                <td className="my-0">
                                  <Form.Control
                                    value={parseFloat(
                                      item.list_curso[0].duracion
                                    )}
                                    className="rounded-pill"
                                    type="number"
                                    disabled
                                  ></Form.Control>
                                </td>
                                <td>
                                  <Col className="d-flex flex-wrap justify-content-end align-items-center">
                                    { props.match.params.miDescriptor ? null : (
                                      <div
                                        className="btn-group d-flex flex-wrap justify-content-end align-items-center"
                                        role="group"
                                      >
                                        <OverlayTrigger
                                          placement="auto"
                                          overlay={
                                            <Tooltip {...props}>
                                              Indispensable
                                            </Tooltip>
                                          }
                                        >
                                          <Form.Check
                                            type="switch"
                                            id={"Preparación " + item.id}
                                            defaultChecked={item.indispensable}
                                            onChange={(e) =>
                                              handleCheckboxPreparation(
                                                e.target.checked,
                                                item.id,
                                                index
                                              )
                                            }
                                          />
                                        </OverlayTrigger>
                                        <OverlayTrigger
                                          placement="auto"
                                          overlay={
                                            <Tooltip {...props}>Editar</Tooltip>
                                          }
                                        >
                                          <Button
                                            size="sm"
                                            variant="link"
                                            type="button"
                                            onClick={() =>
                                              onEditPreparation(item, index)
                                            }
                                          >
                                            <i className="material-icons">
                                              edit
                                            </i>
                                          </Button>
                                        </OverlayTrigger>
                                        <OverlayTrigger
                                          placement="auto"
                                          overlay={
                                            <Tooltip {...props}>
                                              Eliminar
                                            </Tooltip>
                                          }
                                        >
                                          <Button
                                            size="sm"
                                            className="text-danger"
                                            variant="link"
                                            type="button"
                                            onClick={() =>
                                              onDeletePreparation(
                                                item.id,
                                                index
                                              )
                                            }
                                          >
                                            <i className="material-icons">
                                              close
                                            </i>
                                          </Button>
                                        </OverlayTrigger>
                                      </div>
                                    )}
                                  </Col>
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                      ))}
                    </>
                  )
                )}
                {!preparationLoading &&
                  preparationsLength === 0 &&
                  preparationError === "" && (
                    <Alert variant="info" className="my-4 mx-2">
                      Aún no hay registros, comience agregando algunos
                    </Alert>
                  )}
                {!!preparationError && (
                  <Alert variant="danger" className="mt-4 mb-1">
                    {preparationError}
                  </Alert>
                )}
              </Col>
            </Col>
            <Col className="mt-4">
              <Col className="mx-3 d-flex flex-wrap justify-content-between align-items-center">
                <Row className="pl-md-4 pr-md-3 pl-2 pr-1 justify-content-end align-items-center flex-nowrap">
                  <h6 className="font-weight-bold text-uppercase">
                    Conocimiento técnico
                  </h6>
                  { props.match.params.miDescriptor ? null : (
                    <Col xs="auto">
                      <OverlayTrigger
                        placement="auto"
                        overlay={
                          <Tooltip {...props}>
                            Agregar conocimiento técnico
                          </Tooltip>
                        }
                      >
                        <Button
                          variant="primary"
                          size="sm"
                          className="rounded-pill"
                          onClick={() => onAddTecnicalKnowledge()}
                        >
                          Crear nuevo <i className="material-icons">add</i>
                        </Button>
                      </OverlayTrigger>
                    </Col>
                  )}
                </Row>
              </Col>
              <Col>
                <hr className="mb-0" />
              </Col>
            </Col>
            <Col>
              <Col className="px-2">
                {technicalKnowledgeAcquiredLoading ? (
                  <div className="d-flex justify-content-center">
                    <Spinner
                      animation="border"
                      role="status"
                      className="d-flex justify-content-center"
                    />
                  </div>
                ) : (
                  technicalKnowledgeAcquiredsLength > 0 && (
                    <>
                      {technicalKnowledgeAcquireds.map((item, index) => (
                        <div class="table-responsive mx-2">
                          <Table borderless>
                            <thead>
                              <tr>
                                <th style={{ fontWeight: "normal" }}>
                                  Conocimiento técnico
                                </th>
                                <th style={{ fontWeight: "normal" }}>
                                  Nivel de profundidad
                                </th>
                                <th></th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr className="my-0">
                                <td className="my-0">
                                  <Form.Control
                                    value={
                                      item.list_conocimiento
                                        ? item.list_conocimiento[0].nombre
                                        : "no existe"
                                    }
                                    className="rounded-pill"
                                    type="text"
                                    disabled
                                  ></Form.Control>
                                </td>
                                <td className="my-0">
                                  <Form.Control
                                    value={parseFloat(item.nivel_profundidad)}
                                    className="rounded-pill"
                                    type="number"
                                    disabled
                                  ></Form.Control>
                                </td>
                                <td>
                                  <Col className="d-flex justify-content-end align-items-center">
                                    { props.match.params.miDescriptor ? null : (
                                      <div
                                        className="btn-group d-flex justify-content-end align-items-center"
                                        role="group"
                                      >
                                        <OverlayTrigger
                                          placement="auto"
                                          overlay={
                                            <Tooltip {...props}>
                                              Indispensable
                                            </Tooltip>
                                          }
                                        >
                                          <Form.Check
                                            type="switch"
                                            id={"Conocimiento " + item.id}
                                            defaultChecked={item.indispensable}
                                            onChange={(e) => {
                                              console.log(e.target.checked);
                                              handleCheckboxTecnicalKnowledgeAcquired(
                                                e.target.checked,
                                                item.id,
                                                index
                                              );
                                            }}
                                          />
                                        </OverlayTrigger>
                                        <OverlayTrigger
                                          placement="auto"
                                          overlay={
                                            <Tooltip {...props}>Editar</Tooltip>
                                          }
                                        >
                                          <Button
                                            size="sm"
                                            variant="link"
                                            type="button"
                                            onClick={() =>
                                              onEditTecnicalKnowledge(
                                                item,
                                                index
                                              )
                                            }
                                          >
                                            <i className="material-icons">
                                              edit
                                            </i>
                                          </Button>
                                        </OverlayTrigger>
                                        <OverlayTrigger
                                          placement="auto"
                                          overlay={
                                            <Tooltip {...props}>
                                              Eliminar
                                            </Tooltip>
                                          }
                                        >
                                          <Button
                                            size="sm"
                                            className="text-danger"
                                            variant="link"
                                            type="button"
                                            onClick={() =>
                                              onDeleteTecnicalKnowledge(
                                                item.id,
                                                index
                                              )
                                            }
                                          >
                                            <i className="material-icons">
                                              close
                                            </i>
                                          </Button>
                                        </OverlayTrigger>
                                      </div>
                                    )}
                                  </Col>
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                      ))}
                    </>
                  )
                )}
                {!technicalKnowledgeAcquiredLoading &&
                  technicalKnowledgeAcquiredsLength === 0 &&
                  technicalKnowledgeAcquiredError === "" && (
                    <Alert variant="info" className="my-4 mx-2">
                      Aún no hay registros, comience agregando algunos
                    </Alert>
                  )}
                {!!technicalKnowledgeAcquiredError && (
                  <Alert variant="danger" className="mt-4 mb-1">
                    {technicalKnowledgeAcquiredError}
                  </Alert>
                )}
              </Col>
            </Col>
            <Col className="mt-4">
              <Col className="mx-3 d-flex flex-wrap justify-content-between align-items-center">
                <Row className="pl-md-4 pr-md-3 pl-2 pr-1 justify-content-end align-items-center flex-nowrap">
                  <h6 className="font-weight-bold text-uppercase">
                    Experiencia
                  </h6>
                  { props.match.params.miDescriptor ? null : (
                    <Col xs="auto">
                      <OverlayTrigger
                        placement="auto"
                        overlay={
                          <Tooltip {...props}>Agregar Experiencia</Tooltip>
                        }
                      >
                        <Button
                          variant="primary"
                          size="sm"
                          className="rounded-pill"
                          onClick={() => onAddExperience()}
                        >
                          Crear nuevo <i className="material-icons">add</i>
                        </Button>
                      </OverlayTrigger>
                    </Col>
                  )}
                </Row>
              </Col>
              <Col>
                <hr className="mb-0" />
              </Col>
            </Col>
            <Col>
              <Col className="px-2">
                {experienceLoading ? (
                  <div className="d-flex justify-content-center">
                    <Spinner
                      animation="border"
                      role="status"
                      className="d-flex justify-content-center"
                    />
                  </div>
                ) : (
                  experiencesLength > 0 && (
                    <>
                      {experiences.map((item, index) => (
                        <div class="table-responsive mx-2">
                          <Table borderless>
                            <thead>
                              <tr>
                                <th
                                  style={{ fontWeight: "normal" }}
                                  colspan="2"
                                >
                                  Dimensión de experiencia
                                </th>
                                <th></th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr className="my-0">
                                <td style={{ width: "578px" }} className="my-0">
                                  <Row>
                                    <Form.Label column md={1}>
                                      De:
                                    </Form.Label>
                                    <Col md={11}>
                                      <Form.Control
                                        value={
                                          item.tiempo
                                            ? parseInt(item.tiempo)
                                            : "no existe"
                                        }
                                        className="rounded-pill"
                                        type="text"
                                        disabled
                                      ></Form.Control>
                                    </Col>
                                  </Row>
                                </td>
                                <td style={{ width: "578px" }} className="my-0">
                                  <Col className="pl-0 my-0">
                                    <Row>
                                      <Form.Label column md={1}>
                                        Hasta:
                                      </Form.Label>
                                      <Col md={11}>
                                        <Form.Control
                                          value={
                                            item.tiempo_2
                                              ? parseInt(item.tiempo_2)
                                              : "no existe"
                                          }
                                          className="rounded-pill"
                                          type="text"
                                          disabled
                                        ></Form.Control>
                                      </Col>
                                    </Row>
                                  </Col>
                                </td>
                                <td>
                                  <Col className="d-flex justify-content-end align-items-center">
                                    { props.match.params.miDescriptor ? null : (
                                      <div
                                        className="btn-group d-flex justify-content-end align-items-center"
                                        role="group"
                                      >
                                        <OverlayTrigger
                                          placement="auto"
                                          overlay={
                                            <Tooltip {...props}>Editar</Tooltip>
                                          }
                                        >
                                          <Button
                                            size="sm"
                                            variant="link"
                                            type="button"
                                            onClick={() =>
                                              onEditexperience(item, index)
                                            }
                                          >
                                            <i className="material-icons">
                                              edit
                                            </i>
                                          </Button>
                                        </OverlayTrigger>
                                        <OverlayTrigger
                                          placement="auto"
                                          overlay={
                                            <Tooltip {...props}>
                                              Eliminar
                                            </Tooltip>
                                          }
                                        >
                                          <Button
                                            size="sm"
                                            className="text-danger"
                                            variant="link"
                                            type="button"
                                            onClick={() =>
                                              onDeleteExperience(item.id, index)
                                            }
                                          >
                                            <i className="material-icons">
                                              close
                                            </i>
                                          </Button>
                                        </OverlayTrigger>
                                      </div>
                                    )}
                                  </Col>
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                      ))}
                    </>
                  )
                )}
                {!experienceLoading &&
                  experiencesLength === 0 &&
                  experienceError === "" && (
                    <Alert variant="info" className="my-4 mx-2">
                      Aún no hay registros, comience agregando algunos
                    </Alert>
                  )}
                {!!experienceError && (
                  <Alert variant="danger" className="mt-4 mb-1">
                    {experienceError}
                  </Alert>
                )}
              </Col>
            </Col>
          </>
        )}
      </Container>
      <Modal
        show={showModalJobProfile}
        onHide={() => setShowModalJobProfile(false)}
      >
        <Formik
          validationSchema={schemaJobProfile}
          onSubmit={onSubmitJobProfile}
          initialValues={{
            nombre: edit ? editItem.nombre : "",
            titulo: edit ? editItem.formacion : "",
            indispensable_formacion: edit ? editItem.indispensable : false,
          }}
        >
          {({
            handleSubmit,
            handleChange,
            setFieldValue,
            handleBlur,
            values,
            touched,
            errors,
          }) => (
            <Form
              onSubmit={handleSubmit}
              noValidate
              validated={validatedJobProfile}
            >
              <Modal.Header closeButton>
                <Modal.Title className="text-muted">
                  {edit ? "Editar Formación" : "Agregar Formación"}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {!!formError && (
                  <Alert variant="danger" className="mt-4 mb-1 mx-3">
                    {formError}
                  </Alert>
                )}
                <Form.Group as={Col} className="mb-3">
                  <Form.Label column sm="12" md="12">
                    Formación
                  </Form.Label>
                  <Form.Control
                    id="nombre"
                    name="nombre"
                    isInvalid={touched.nombre && errors.nombre}
                    isValid={touched.nombre && !errors.nombre}
                    onBlur={handleBlur("nombre")}
                    onChange={handleChange}
                    value={values.nombre}
                    className="rounded-pill"
                    type="text"
                    placeholder="Formación"
                  ></Form.Control>
                  {touched.nombre && errors.nombre && (
                    <div>
                      <small className="text-danger">{errors.nombre}</small>
                    </div>
                  )}
                </Form.Group>
                <Form.Group as={Col} className="mb-3">
                  <Form.Label column sm="12" md="12">
                    Título
                  </Form.Label>
                  <Row>
                    <Col sm="12" md="12">
                      <Typeahead
                        id="titulo"
                        name="titulo"
                        isInvalid={touched.titulo && errors.titulo}
                        isValid={touched.titulo && !errors.titulo}
                        onBlur={handleBlur("titulo")}
                        placeholder="Título"
                        options={titleOptions}
                        onChange={(selected) => {
                          setFieldValue(
                            "titulo",
                            selected.length > 0 ? selected[0].id : ""
                          );
                          setTitleSelected(selected);
                        }}
                        selected={titleSelected}
                        disabled={titlesLength === 0}
                      ></Typeahead>
                    </Col>
                  </Row>
                  {touched.titulo && errors.titulo && (
                    <div>
                      <small className="text-danger">{errors.titulo}</small>
                    </div>
                  )}
                </Form.Group>
                <Form.Group as={Col} className="mb-3">
                  <Form.Label column sm="12" md="12">
                    Nivel de educación
                  </Form.Label>
                  <Form.Control
                    value={
                      titleSelected &&
                      titleSelected.length > 0 &&
                      titleSelected[0].titleObject &&
                      titleSelected[0].titleObject.list_nivel_academico
                        ? titleSelected[0].titleObject.list_nivel_academico[0]
                            .nombre
                        : null
                    }
                    className="rounded-pill"
                    type="text"
                    placeholder="Nivel de educación"
                    disabled
                  ></Form.Control>
                </Form.Group>
                <Form.Group as={Col} className="mb-3">
                  <Form.Label column sm="12" md="12">
                    Área de conocimiento
                  </Form.Label>
                  <Form.Control
                    value={
                      titleSelected &&
                      titleSelected.length > 0 &&
                      titleSelected[0].titleObject &&
                      titleSelected[0].titleObject.list_area_conocimiento
                        ? titleSelected[0].titleObject.list_area_conocimiento[0]
                            .nombre
                        : null
                    }
                    className="rounded-pill"
                    type="text"
                    placeholder="Área de conocimiento"
                    disabled
                  ></Form.Control>
                </Form.Group>
                <Form.Group as={Col} className="mx-2 my-3">
                  <div className="d-flex aling-items-center justify-content-between pl-2 pr-3 pt-3">
                    <label htmlFor="active">
                      Indique si es deseable o indispensable
                    </label>
                    <Form.Check
                      id="indispensable_formacion"
                      name="indispensable_formacion"
                      isInvalid={
                        touched.indispensable_formacion &&
                        errors.indispensable_formacion
                      }
                      isValid={
                        touched.indispensable_formacion &&
                        !errors.indispensable_formacion
                      }
                      onBlur={handleBlur("indispensable_formacion")}
                      onChange={(e) => {
                        setFieldValue(
                          "indispensable_formacion",
                          e.target.checked
                        );
                      }}
                      value={values.indispensable_formacion}
                      className="rounded-pill"
                      type="switch"
                      defaultChecked={edit ? editItem.indispensable : null}
                    />
                    {touched.indispensable_formacion &&
                      errors.indispensable_formacion && (
                        <div>
                          <small className="text-danger">
                            {errors.indispensable_formacion}
                          </small>
                        </div>
                      )}
                  </div>
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="rounded-pill"
                  variant="secondary"
                  onClick={() => setShowModalJobProfile(false)}
                >
                  Cerrar
                </Button>
                <Button
                  className="rounded-pill"
                  variant="primary"
                  disabled={trainingSaveLoading}
                  type="submit"
                >
                  {trainingSaveLoading && (
                    <Spinner
                      className="mr-2"
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  )}
                  Guardar
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
      <Modal
        show={showModalPreparation}
        onHide={() => setShowModalPreparation(false)}
      >
        <Formik
          validationSchema={schemaPreparation}
          onSubmit={onSubmitPreparation}
          initialValues={{
            descripcion: _editPreparation
              ? editItemPreparation.descripcion
              : "",
            curso: _editPreparation ? editItemPreparation.curso : "",
            indispensable: _editPreparation
              ? editItemPreparation.indispensable
              : false,
          }}
        >
          {({
            handleSubmit,
            handleChange,
            setFieldValue,
            handleBlur,
            values,
            touched,
            errors,
          }) => (
            <Form
              onSubmit={handleSubmit}
              noValidate
              validated={validatedPreparation}
            >
              <Modal.Header closeButton>
                <Modal.Title className="text-muted">
                  {_editPreparation
                    ? "Editar Preparación"
                    : "Agregar Preparación"}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {!!preparationFormError && (
                  <Alert variant="danger" className="mt-4 mb-1 mx-3">
                    {preparationFormError}
                  </Alert>
                )}

                <Form.Group as={Col} className="mb-3">
                  <Form.Label column sm="12" md="12">
                    Curso
                  </Form.Label>
                  <Row>
                    <Col sm="12" md="12">
                      <Typeahead
                        id="curso"
                        name="curso"
                        isInvalid={touched.curso && errors.curso}
                        isValid={touched.curso && !errors.curso}
                        onBlur={handleBlur("curso")}
                        placeholder="Curso"
                        options={courseOptions}
                        onChange={(selected) => {
                          setFieldValue(
                            "curso",
                            selected.length > 0 ? selected[0].id : ""
                          );
                          setCourseSelected(selected);
                        }}
                        selected={courseSelected}
                        disabled={coursesLength === 0}
                      ></Typeahead>
                    </Col>
                  </Row>
                  {touched.curso && errors.curso && (
                    <div>
                      <small className="text-danger">{errors.curso}</small>
                    </div>
                  )}
                </Form.Group>
                <Form.Group as={Col} className="mb-3">
                  <Form.Label column sm="12" md="12">
                    Descripción
                  </Form.Label>
                  <Form.Control
                    id="descripcion"
                    name="descripcion"
                    isInvalid={touched.descripcion && errors.descripcion}
                    isValid={touched.descripcion && !errors.descripcion}
                    onBlur={handleBlur("descripcion")}
                    onChange={handleChange}
                    value={values.descripcion}
                    className="rounded"
                    as="textarea"
                    placeholder="Descripción de la preparación"
                  ></Form.Control>
                  {touched.descripcion && errors.descripcion && (
                    <div>
                      <small className="text-danger">
                        {errors.descripcion}
                      </small>
                    </div>
                  )}
                </Form.Group>
                <Form.Group as={Col} className="mb-3">
                  <Form.Label column sm="12" md="12">
                    Duración
                  </Form.Label>
                  <Form.Control
                    value={
                      courseSelected &&
                      courseSelected.length > 0 &&
                      courseSelected[0].courseObject &&
                      courseSelected[0].courseObject.duracion
                        ? parseFloat(courseSelected[0].courseObject.duracion)
                        : null
                    }
                    className="rounded-pill"
                    type="number"
                    placeholder="00.00"
                    disabled
                  ></Form.Control>
                </Form.Group>
                <Form.Group as={Col} className="mx-2 my-3">
                  <div className="d-flex aling-items-center justify-content-between pl-2 pr-3 pt-3">
                    <label htmlFor="active">
                      Indique si es deseable o indispensable
                    </label>
                    <Form.Check
                      id="indispensable"
                      name="indispensable"
                      isInvalid={touched.indispensable && errors.indispensable}
                      isValid={touched.indispensable && !errors.indispensable}
                      onBlur={handleBlur("indispensable")}
                      onChange={(e) => {
                        setFieldValue("indispensable", e.target.checked);
                      }}
                      value={values.indispensable}
                      className="rounded-pill"
                      type="switch"
                      defaultChecked={
                        _editPreparation
                          ? editItemPreparation.indispensable
                          : null
                      }
                    />
                    {touched.indispensable && errors.indispensable && (
                      <div>
                        <small className="text-danger">
                          {errors.indispensable}
                        </small>
                      </div>
                    )}
                  </div>
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="rounded-pill"
                  variant="secondary"
                  onClick={() => setShowModalPreparation(false)}
                >
                  Cerrar
                </Button>
                <Button
                  className="rounded-pill"
                  variant="primary"
                  disabled={preparationSaveLoading}
                  type="submit"
                >
                  {preparationSaveLoading && (
                    <Spinner
                      className="mr-2"
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  )}
                  Guardar
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
      <Modal
        show={showModalTecnicalKnowledge}
        onHide={() => setShowModalTecnicalKnowledge(false)}
        size="lg"
      >
        <Formik
          validationSchema={schemaTecnicalKnowledge}
          onSubmit={onSubmitTecnicalKnowledge}
          initialValues={{
            nombre: editTecnicalKnowledge
              ? editItemTecnicalKnowledge.nombre
              : "",
            descripcion: editTecnicalKnowledge
              ? editItemTecnicalKnowledge.descripcion
              : "",
            conocimiento: editTecnicalKnowledge
              ? editItemTecnicalKnowledge.conocimiento
              : "",
            nivel_profundidad: editTecnicalKnowledge
              ? editItemTecnicalKnowledge.nivel_profundidad
              : null,
            indispensableConocimiento: editTecnicalKnowledge
              ? editItemTecnicalKnowledge.indispensable
              : false,
          }}
        >
          {({
            handleSubmit,
            handleChange,
            setFieldValue,
            handleBlur,
            values,
            touched,
            errors,
          }) => (
            <Form
              onSubmit={handleSubmit}
              noValidate
              validated={validatedTecnicalKnowledge}
            >
              <Modal.Header closeButton>
                <Modal.Title className="text-muted">
                  {editTecnicalKnowledge
                    ? "Editar conocimiento técnico"
                    : "Agregar conocimiento técnico"}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {!!preparationFormError && (
                  <Alert variant="danger" className="mt-4 mb-1 mx-3">
                    {preparationFormError}
                  </Alert>
                )}
                <Col>
                  <Row>
                    <Form.Group as={Col} className="mb-3">
                      <Form.Label
                        column
                        sm="12"
                        md="12"
                        style={{
                          // paddingLeft: "0",
                          width: "100%",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Nombre
                      </Form.Label>
                      <Form.Control
                        id="nombre"
                        name="nombre"
                        isInvalid={touched.nombre && errors.nombre}
                        isValid={touched.nombre && !errors.nombre}
                        onBlur={handleBlur("nombre")}
                        onChange={handleChange}
                        value={values.nombre}
                        className="rounded-pill"
                        type="text"
                        placeholder="Nombre del conocimiento tecnico"
                      ></Form.Control>
                      {touched.nombre && errors.nombre && (
                        <div>
                          <small className="text-danger">{errors.nombre}</small>
                        </div>
                      )}
                    </Form.Group>
                    <Form.Group as={Col} className="mb-3">
                      <Form.Label
                        column
                        sm="12"
                        md="12"
                        style={{
                          // paddingLeft: "0",
                          width: "100%",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Conocimiento técnico
                      </Form.Label>
                      <Row>
                        <Col sm="12" md="12">
                          <Typeahead
                            id="conocimiento"
                            name="conocimiento"
                            isInvalid={
                              touched.conocimiento && errors.conocimiento
                            }
                            isValid={
                              touched.conocimiento && !errors.conocimiento
                            }
                            onBlur={handleBlur("conocimiento")}
                            placeholder="Conocimiento técnico"
                            options={knowledgeOptions}
                            onChange={(selected) => {
                              setFieldValue(
                                "conocimiento",
                                selected.length > 0 ? selected[0].id : ""
                              );
                              setknowledgeSelected(selected);
                            }}
                            selected={knowledgeSelected}
                            disabled={technicalKnowledgesLength === 0}
                          ></Typeahead>
                        </Col>
                      </Row>
                      {touched.conocimiento && errors.conocimiento && (
                        <div>
                          <small className="text-danger">
                            {errors.conocimiento}
                          </small>
                        </div>
                      )}
                    </Form.Group>
                    <Form.Group as={Col} className="mb-3">
                      <Form.Label
                        column
                        sm="12"
                        md="12"
                        style={{
                          // paddingLeft: "0",
                          width: "100%",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Nivel de profundidad
                      </Form.Label>
                      <Form.Control
                        id="nivel_profundidad"
                        name="nivel_profundidad"
                        isInvalid={
                          touched.nivel_profundidad && errors.nivel_profundidad
                        }
                        isValid={
                          touched.nivel_profundidad && !errors.nivel_profundidad
                        }
                        onBlur={handleBlur("nivel_profundidad")}
                        onChange={handleChange}
                        value={values.nivel_profundidad}
                        className="rounded-pill"
                        type="number"
                        placeholder="1"
                        min={1}
                        max={3}
                      ></Form.Control>
                      {touched.nivel_profundidad &&
                        errors.nivel_profundidad && (
                          <Col>
                            <small className="text-danger">
                              {errors.nivel_profundidad}
                            </small>
                          </Col>
                        )}
                    </Form.Group>
                  </Row>
                </Col>
                <Form.Group as={Col} className="mb-3">
                  <Form.Label column sm="12" md="12">
                    Descripción
                  </Form.Label>
                  <Form.Control
                    id="descripcion"
                    name="descripcion"
                    isInvalid={touched.descripcion && errors.descripcion}
                    isValid={touched.descripcion && !errors.descripcion}
                    onBlur={handleBlur("descripcion")}
                    onChange={handleChange}
                    value={values.descripcion}
                    className="rounded"
                    as="textarea"
                    placeholder="Descripción del conocimiento técnico adquirido"
                  ></Form.Control>
                  {touched.descripcion && errors.descripcion && (
                    <div>
                      <small className="text-danger">
                        {errors.descripcion}
                      </small>
                    </div>
                  )}
                </Form.Group>
                <Form.Group as={Col} className="mx-2 my-3">
                  <div className="d-flex aling-items-center justify-content-between pl-2 pr-3 pt-3">
                    <label htmlFor="active">
                      Indique si es deseable o indispensable
                    </label>
                    <Form.Check
                      id="indispensableConocimiento"
                      name="indispensableConocimiento"
                      isInvalid={
                        touched.indispensableConocimiento &&
                        errors.indispensableConocimiento
                      }
                      isValid={
                        touched.indispensableConocimiento &&
                        !errors.indispensableConocimiento
                      }
                      onBlur={handleBlur("indispensableConocimiento")}
                      onChange={(e) => {
                        setFieldValue(
                          "indispensableConocimiento",
                          e.target.checked
                        );
                      }}
                      value={values.indispensableConocimiento}
                      className="rounded-pill"
                      type="switch"
                      defaultChecked={
                        editTecnicalKnowledge
                          ? editItemTecnicalKnowledge.indispensable
                          : null
                      }
                    />
                    {touched.indispensableConocimiento &&
                      errors.indispensableConocimiento && (
                        <div>
                          <small className="text-danger">
                            {errors.indispensableConocimiento}
                          </small>
                        </div>
                      )}
                  </div>
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="rounded-pill"
                  variant="secondary"
                  onClick={() => setShowModalPreparation(false)}
                >
                  Cerrar
                </Button>
                <Button
                  className="rounded-pill"
                  variant="primary"
                  disabled={preparationSaveLoading}
                  type="submit"
                >
                  {preparationSaveLoading && (
                    <Spinner
                      className="mr-2"
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  )}
                  Guardar
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
      <Modal
        show={showModalExperience}
        onHide={() => setShowModalExperience(false)}
        size="lg"
      >
        <Formik
          validationSchema={schemaExperience}
          onSubmit={onSubmitExperience}
          initialValues={{
            // detalle: _editExperience ? editItemExperience.detalle : "",
            tiempo:
              _editExperience && editItemExperience.tiempo
                ? parseInt(editItemExperience.tiempo)
                : "",
            tiempo_2:
              _editExperience && editItemExperience.tiempo_2
                ? parseInt(editItemExperience.tiempo_2)
                : "",
            experiencia_tipo_institucion: _editExperience
              ? editItemExperience.experiencia_tipo_institucion
              : false,
            experiencia_tipo_institucion_detalle:
              _editExperience &&
              editItemExperience.experiencia_tipo_institucion_detalle
                ? editItemExperience.experiencia_tipo_institucion_detalle
                : "",
            experiencia_tipo_cargo: _editExperience
              ? editItemExperience.experiencia_tipo_cargo
              : false,
            experiencia_tipo_cargo_detalle:
              _editExperience &&
              editItemExperience.experiencia_tipo_cargo_detalle
                ? editItemExperience.experiencia_tipo_cargo_detalle
                : "",
          }}
        >
          {({
            handleSubmit,
            handleChange,
            setFieldValue,
            handleBlur,
            values,
            touched,
            errors,
          }) => (
            <Form
              onSubmit={handleSubmit}
              noValidate
              validated={validatedExperience}
            >
              <Modal.Header closeButton>
                <Modal.Title className="text-muted">
                  {editTecnicalKnowledge
                    ? "Editar experiencia"
                    : "Agregar experiencia"}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {!!preparationFormError && (
                  <Alert variant="danger" className="mt-4 mb-1 mx-3">
                    {preparationFormError}
                  </Alert>
                )}
                <Form.Group as={Col} className="mb-3">
                  <Form.Label
                    column
                    sm="12"
                    md="12"
                    style={{
                      // paddingLeft: "0",
                      width: "100%",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Dimensión de experiencia
                  </Form.Label>
                  {/* <Form.Control
                    id="tiempo"
                    name="tiempo"
                    isInvalid={touched.tiempo && errors.tiempo}
                    isValid={touched.tiempo && !errors.tiempo}
                    onBlur={handleBlur("tiempo")}
                    onChange={handleChange}
                    value={values.tiempo}
                    className="rounded-pill"
                    type="number"
                    placeholder="0.00"
                  ></Form.Control> */}
                  <Col>
                    <Row className="d-flex flex-wrap justify-content-between">
                      <Form.Label column md={1}>
                        De:
                      </Form.Label>
                      <Col md={5}>
                        <Form.Control
                          id="tiempo"
                          name="tiempo"
                          isInvalid={touched.tiempo && errors.tiempo}
                          isValid={touched.tiempo && !errors.tiempo}
                          onBlur={handleBlur("tiempo")}
                          onChange={handleChange}
                          value={values.tiempo}
                          className="rounded-pill"
                          type="number"
                          placeholder="de"
                          min={0}
                          max={100}
                        ></Form.Control>
                        {touched.tiempo && !!errors.tiempo && (
                          <Col>
                            <small className="text-danger">
                              {errors.tiempo}
                            </small>
                          </Col>
                        )}
                      </Col>
                      <Form.Label column md={1}>
                        Hasta:
                      </Form.Label>
                      <Col md={5}>
                        <Form.Control
                          id="tiempo_2"
                          name="tiempo_2"
                          isInvalid={touched.tiempo_2 && errors.tiempo_2}
                          isValid={touched.tiempo_2 && !errors.tiempo_2}
                          onBlur={handleBlur("tiempo_2")}
                          onChange={handleChange}
                          value={values.tiempo_2}
                          className="rounded-pill"
                          type="number"
                          placeholder="hasta"
                          min={0}
                          max={100}
                        ></Form.Control>
                        {touched.tiempo_2 && !!errors.tiempo_2 && (
                          <Col>
                            <small className="text-danger">
                              {errors.tiempo_2}
                            </small>
                          </Col>
                        )}
                      </Col>
                    </Row>
                  </Col>
                </Form.Group>
                {/* <Form.Group as={Col} className="mb-3">
                  <Form.Label column sm="12" md="12">
                    Detalle
                  </Form.Label>
                  <Form.Control
                    id="detalle"
                    name="detalle"
                    isInvalid={touched.detalle && errors.detalle}
                    isValid={touched.detalle && !errors.detalle}
                    onBlur={handleBlur("detalle")}
                    onChange={handleChange}
                    value={values.detalle}
                    className="rounded"
                    as="textarea"
                    placeholder="Detalle de la experiencia"
                  ></Form.Control>
                  {touched.detalle && errors.detalle && (
                    <div>
                      <small className="text-danger">{errors.detalle}</small>
                    </div>
                  )}
                </Form.Group> */}
                <Form.Group as={Col} className="mx-2 my-3">
                  <div className="d-flex aling-items-center justify-content-between pl-2 pr-3 pt-3">
                    <label htmlFor="active">Experiencia en institución</label>
                    <Form.Check
                      id="experiencia_tipo_institucion"
                      name="experiencia_tipo_institucion"
                      isInvalid={
                        touched.experiencia_tipo_institucion &&
                        errors.experiencia_tipo_institucion
                      }
                      isValid={
                        touched.experiencia_tipo_institucion &&
                        !errors.experiencia_tipo_institucion
                      }
                      onBlur={handleBlur("experiencia_tipo_institucion")}
                      onChange={(e) => {
                        setFieldValue(
                          "experiencia_tipo_institucion",
                          e.target.checked
                        );
                      }}
                      value={values.experiencia_tipo_institucion}
                      className="rounded-pill"
                      type="switch"
                      defaultChecked={
                        _editExperience
                          ? editItemExperience.experiencia_tipo_institucion
                          : null
                      }
                    />
                    {touched.experiencia_tipo_institucion &&
                      errors.experiencia_tipo_institucion && (
                        <div>
                          <small className="text-danger">
                            {errors.experiencia_tipo_institucion}
                          </small>
                        </div>
                      )}
                  </div>
                </Form.Group>
                <Form.Group as={Col} className="mb-3">
                  <Form.Control
                    id="experiencia_tipo_institucion_detalle"
                    name="experiencia_tipo_institucion_detalle"
                    isInvalid={
                      touched.experiencia_tipo_institucion_detalle &&
                      errors.experiencia_tipo_institucion_detalle
                    }
                    isValid={
                      touched.experiencia_tipo_institucion_detalle &&
                      !errors.experiencia_tipo_institucion_detalle
                    }
                    onBlur={handleBlur("experiencia_tipo_institucion_detalle")}
                    onChange={handleChange}
                    value={
                      values.experiencia_tipo_institucion
                        ? values.experiencia_tipo_institucion_detalle
                        : ""
                    }
                    className="rounded"
                    as="textarea"
                    placeholder="Experiencia en institución"
                    disabled={!values.experiencia_tipo_institucion}
                  ></Form.Control>
                  {touched.experiencia_tipo_institucion_detalle &&
                    errors.experiencia_tipo_institucion_detalle && (
                      <div>
                        <small className="text-danger">
                          {errors.experiencia_tipo_institucion_detalle}
                        </small>
                      </div>
                    )}
                </Form.Group>
                <Form.Group as={Col} className="mx-2 my-3">
                  <div className="d-flex aling-items-center justify-content-between pl-2 pr-3 pt-3">
                    <label htmlFor="active">Experiencia en el cargo</label>
                    <Form.Check
                      id="experiencia_tipo_cargo"
                      name="experiencia_tipo_cargo"
                      isInvalid={
                        touched.experiencia_tipo_cargo &&
                        errors.experiencia_tipo_cargo
                      }
                      isValid={
                        touched.experiencia_tipo_cargo &&
                        !errors.experiencia_tipo_cargo
                      }
                      onBlur={handleBlur("experiencia_tipo_cargo")}
                      onChange={(e) => {
                        setFieldValue(
                          "experiencia_tipo_cargo",
                          e.target.checked
                        );
                      }}
                      value={values.experiencia_tipo_cargo}
                      className="rounded-pill"
                      type="switch"
                      defaultChecked={
                        _editExperience
                          ? editItemExperience.experiencia_tipo_cargo
                          : null
                      }
                    />
                    {touched.experiencia_tipo_cargo &&
                      errors.experiencia_tipo_cargo && (
                        <div>
                          <small className="text-danger">
                            {errors.experiencia_tipo_cargo}
                          </small>
                        </div>
                      )}
                  </div>
                </Form.Group>
                <Form.Group as={Col} className="mb-3">
                  <Form.Control
                    id="experiencia_tipo_cargo_detalle"
                    name="experiencia_tipo_cargo_detalle"
                    isInvalid={
                      touched.experiencia_tipo_cargo_detalle &&
                      errors.experiencia_tipo_cargo_detalle
                    }
                    isValid={
                      touched.experiencia_tipo_cargo_detalle &&
                      !errors.experiencia_tipo_cargo_detalle
                    }
                    onBlur={handleBlur("experiencia_tipo_cargo_detalle")}
                    onChange={handleChange}
                    value={
                      values.experiencia_tipo_cargo
                        ? values.experiencia_tipo_cargo_detalle
                        : ""
                    }
                    className="rounded"
                    as="textarea"
                    placeholder="Experiencia en el cargo"
                    disabled={!values.experiencia_tipo_cargo}
                  ></Form.Control>
                  {touched.experiencia_tipo_cargo_detalle &&
                    errors.experiencia_tipo_cargo_detalle && (
                      <div>
                        <small className="text-danger">
                          {errors.experiencia_tipo_cargo_detalle}
                        </small>
                      </div>
                    )}
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="rounded-pill"
                  variant="secondary"
                  onClick={() => setShowModalExperience(false)}
                >
                  Cerrar
                </Button>
                <Button
                  className="rounded-pill"
                  variant="primary"
                  disabled={preparationSaveLoading}
                  type="submit"
                >
                  {preparationSaveLoading && (
                    <Spinner
                      className="mr-2"
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  )}
                  Guardar
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

export default JobProfile;
